module.exports = __webpack_public_path__ + "static/img/linfei.b054bf25.svg";